import type { ApiResponse } from "@membentry/shared-types";

/**
 * Derive the next page index for paginated API responses.
 */
export function getNextPageFromMeta<T>(
  lastPage: ApiResponse<T[]>,
  allPagesCount: number,
  pageSize: number,
): number | undefined {
  const currentPage = lastPage.meta?.page ?? allPagesCount - 1;
  const totalPages = lastPage.meta?.totalPages;

  if (typeof totalPages === "number") {
    return currentPage + 1 < totalPages ? currentPage + 1 : undefined;
  }

  const itemCount = Array.isArray(lastPage.payload) ? lastPage.payload.length : 0;
  return itemCount === pageSize ? currentPage + 1 : undefined;
}
